<script setup lang="ts">
import SmallModel from '@/components/Interface/Modal/ModelSizes/SmallModel.vue'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import { useMapSettingsStore } from '@/stores/mapSettingsStore.ts'
import ToggleSwitch from '@/components/Interface/ToggleSwitch/ToggleSwitch.vue'

const mapSettings = useMapSettingsStore()
</script>

<template>
  <SmallModel title="Map Settings">
    <StandardCard class="p-2" top-padding="0">
      <div class="flex justify-between items-center">
        <div>
          <div class="font-bold">Scan Range Map</div>
          <small class="text-gray-500"> Show what space is in range of your scanners </small>
        </div>
        <div>
          <ToggleSwitch v-model="mapSettings.showScanRange" />
        </div>
      </div>
    </StandardCard>
    <StandardCard class="px-2 pb-2" top-padding="0">
      <div class="flex justify-between items-center">
        <div>
          <div class="font-bold">Mouse Wheel Zoom</div>
          <small class="text-gray-500"> Enable zooming with the mouse wheel </small>
        </div>
        <div>
          <ToggleSwitch v-model="mapSettings.enableMouseWheelZoom" />
        </div>
      </div>
    </StandardCard>
    <StandardCard class="px-2 pb-2" top-padding="0">
      <div class="flex justify-between items-center">
        <div>
          <div class="font-bold">Hide Background Image</div>
          <small class="text-gray-500"> Hide the background image on the map </small>
        </div>
        <div>
          <ToggleSwitch v-model="mapSettings.hideBackgroundImage" />
        </div>
      </div>
    </StandardCard>
    <StandardCard class="px-2 pb-2" top-padding="0">
      <div class="flex justify-between items-center">
        <div>
          <div class="font-bold">Remember Tooltip Position</div>
          <small class="text-gray-500"> Keep tooltip at the last dragged position (useful on small screens/mobile) </small>
        </div>
        <div>
          <ToggleSwitch v-model="mapSettings.rememberTooltipPosition" />
        </div>
      </div>
    </StandardCard>
    <StandardCard class="px-2 pb-2" top-padding="0">
      <div class="flex justify-between items-center">
        <div>
          <div class="font-bold">Show Ship & Fleet Action Paths</div>
          <small class="text-gray-500"> Display action queues for individual ships (dark gray) and fleets (blue) </small>
        </div>
        <div>
          <ToggleSwitch v-model="mapSettings.showAllShipActionPaths" />
        </div>
      </div>
    </StandardCard>
    <StandardCard class="px-2 pb-2" top-padding="0">
      <div class="flex justify-between items-center">
        <div>
          <div class="font-bold">Highlight Large Fleets</div>
          <small class="text-gray-500"> Highlight fleets with more than 50 ships in scanning range </small>
        </div>
        <div>
          <ToggleSwitch v-model="mapSettings.showLargeFleets" />
        </div>
      </div>
    </StandardCard>
    <StandardCard class="px-2 pb-2" top-padding="0">
      <div class="flex justify-between items-center">
        <div>
          <div class="font-bold">Territory Overlay</div>
          <small class="text-gray-500"> Show color-coded territorial boundaries for each player </small>
        </div>
        <div>
          <ToggleSwitch v-model="mapSettings.showTerritoryOverlay" />
        </div>
      </div>
      <div v-if="mapSettings.showTerritoryOverlay" class="mt-4">
        <div class="relative mb-6">
          <input
            type="range"
            id="territoryOpacity"
            min="5"
            max="60"
            step="5"
            v-model.number="mapSettings.territoryOpacity"
            class="w-full h-2 rounded-lg appearance-none cursor-pointer bg-gray-700"
          >
          <span class="text-subtext absolute start-0 -bottom-6">
            Opacity: <span class="text-slate-300">{{ mapSettings.territoryOpacity }}%</span>
          </span>
        </div>
      </div>
    </StandardCard>
  </SmallModel>
</template>
